import GeneratePDF from "../../../../component/PDFGenerator";
import { formatAmount } from "../../../../helper/formatAmount";
import { changeDateFormate } from "../../../../helper/changeDateFormate";

const formatIban = (iban) => {
    return iban ? iban.replace(/(.{4})(?=.)/g, '$1 ') : ''; // Insert a space every 4 characters
};

const GenerateKontenPDF = ({ data, orientation }) => {
    const excludedKeys = ['_id', 'createdAt', 'updatedAt', 'isDeleted', '__v', 'company', "isManual"];

    const customLabels = {
        "bank_name": 'Bank Name',
        "iban": 'Iban',
        "kontostand": "Kontostand",
        "currency": "Currency",
        "ursprungsbetrag": "Ursprungsbetrag",
        "zahlungsbeginn": "Zahlungsbeginn",
        "zahlungsende": "Zahlungsende",
        "monatliche_rate": 'Monatliche Rate',
        "ausstehender_betrag": "Ausstehender Betrag",
        "zahlung_status": "Zahlungsstatus"
    };

    const customColumnOrder = [
        'bank_name',
        'iban',
        'kontostand',
        'currency',
    ];

    const formatCell = (key, value) => {
        if (['kontostand', 'ursprungsbetrag', 'monatliche_rate', 'ausstehender_betrag'].includes(key)) {
            return formatAmount(value) + " €";
        } else if (['zahlungsbeginn', 'zahlungsende'].includes(key)) {
            return changeDateFormate(value);
        } else if (key === 'iban') {
            return formatIban(value);
        }
        return value || '-';
    };

    return (
        <div>
            <GeneratePDF
                orientation={orientation}
                data={data}
                excludedKeys={excludedKeys}
                customLabels={customLabels}
                customColumnOrder={customColumnOrder}
                customRowsPerPage={30}
                formatCell={formatCell}
            />
        </div>
    )
}

export default GenerateKontenPDF;